/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ForumWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACE0lEQVR4nNVVPWsVQRQNqJ2KYmVMYRW1ERsVJfI6jezejxU25+57yOsehPwGQWxS+ZUfkE4boyBop1hrFVJrIggWRkXxAw0YZfa9JbvJfsx7nQMXdmfOnDN35tyZsbH/obVard2keMRiD+M43uU1qdfr7SG1hAX3WfCGFd9dkNhrUrtHijDDcmRzrPbXBSlmG8lFEmLB22xSeWDJYYOgfZAV66S26MJ9i3QPVJKT4BqrbdaRk9hvVUz28XbH9QVBfITZxgdZ3ConV8zWr9oygZsOH15JjpNgw/WF0cxp1eRMfxwbzPGxAnkUdSZI7FujgNiHbAtI8XRLFC9Z7FXu/0lBgNVu+KyeI5tLV6+4nO8XwflQk6li38ylLQGxZQ+BTWbeN1j9Sn7MkYvgwrZsl3MZ4KtPBnEc7+0L2AsP/LOce+ynTwaqONHo8woHrdQ7B+9DxcWRyAcZzNeRR1FnwuFSvysWSG3N1YMrSFI8YLaztQKOgNV+lJD/CTU55zDuEEnsU019zNeKsOD5jkmKx+lYWqX43FiEat2KLcL1Ct8HqYBiwa/K8c5dlEVytW7VBBEcHWDWvArRiZCdLAiIoJ0e2A4w1rP7ndV++QowG3v4atv5qK36Coi0Tw0tQIK7vgKqVw8NnwHbeJ1Fyy7EoVuoyRQJPjY7yb5MT3f2jyQSRZ3DrLjt3unssSmJ1ZEFhm3/AGqxYUKV6zKNAAAAAElFTkSuQmCC)
 */
export const ForumWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 1.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.92 1.92 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.8 3.34a.48.48 0 0 0-.24-.69A9.94 9.94 0 0 0 11 2c-4.97 0-9 3.58-9 8 0 1.5.47 2.91 1.28 4.11.14.21.12.49-.06.67l-1.51 1.51A1 1 0 0 0 2.4 18h5.1a.5.5 0 0 0 .49-.5c0-2.86 1.62-5.3 3.97-6.56.28-.15.38-.51.25-.8a2.86 2.86 0 0 1 .18-2.61l2.4-4.19ZM18.91 12.98a5.45 5.45 0 0 1 2.18 6.2c-.1.33-.09.68.1.96l.83 1.32a1 1 0 0 1-.84 1.54h-5.5A5.6 5.6 0 0 1 10 17.5a5.6 5.6 0 0 1 5.68-5.5c1.2 0 2.32.36 3.23.98Z"
        className={colorClass}
      />
    </svg>
  );
};
